import { Component } from "@angular/core";
import { MenuData, ServicesSlug } from "src/app/shared/models/interfaces";

@Component({
  selector: "app-menu",
  templateUrl: "./menu.component.html",
  styleUrls: ["./menu.component.scss"],
})
export class MenuComponent {
  isSideNavOpened = true;

  menuData: MenuData[] = [
    {
      title: "home",
      url: "/home",
      iconImageName: "home.png",
    },
    {
      title: "user-management",
      url: "/users",
      iconImageName: "users.png",
      child: [
        {
          title: "user-management",
          url: "/user-management",
          permission: "users",
        },
        {
          title: "supervisor-management",
          url: "/supervisor-management",
          permission: "users",
        },
        {
          title: "lawyer-management",
          url: "/lawyer-management",
          permission: "users",
        },
        {
          title: "conciliator-management",
          url: "/conciliator-management",
          permission: "users",
        },
        // NOTE: don't remove maybe add later
        // {
        //   title: "call-center-management",
        //   url: "/call-center-management",
        //   permission: "users",
        // },
      ],
    },
    {
      title: "services-management",
      url: "/user-cases",
      iconImageName: "cases.png",
      child: [
        {
          title: "user-cases",
          url: "/user-cases",
          permission: "users",
        },
        {
          title: "user-inquiries",
          url: "/user-inquiries",
          permission: "users",
        },
      ],
    },
    {
      title: "payments",
      url: "/payments",
      iconImageName: "payments.png",
    },
    {
      title: "cms",
      url: "/cms",
      iconImageName: "cms.png",
      child: [
        {
          title: "cases-types",
          url: "/cases-types",
          permission: "casesTypes",
        },
        {
          title: "ad-boards-management",
          url: "/ad-boards",
          permission: "users",
        },
        {
          title: "pages",
          url: "/pages",
          permission: "pages",
        },
        {
          title: "faqCategories",
          url: "/faqCategories",
          permission: "faqCategories",
        },
        {
          title: "faq",
          url: "/faq",
          permission: "faq",
        },
      ],
    },
    {
      title: "complaints",
      url: "/complaints",
      icon: "flag",
    },
    {
      title: "reports",
      url: "/reports",
      iconImageName: "reports.png",
      child: [
        {
          title: "lawyers-reports",
          url: "/lawyers-reports",
          permission: "lawyersReports",
        },
        {
          title: "conciliator-reports",
          url: "/conciliator-reports",
          permission: "conciliatorReports",
        },
        {
          title: "services-statistics-reports",
          url: "/services-statistics-reports",
          permission: "servicesStatisticsReports",
        },
        {
          title: "inquiries-types-reports",
          url: "/inquiries-types-reports",
          permission: "inquiriesTypesReports",
        },
        {
          title: "cases-types-reports",
          url: "/cases-types-reports",
          permission: "casesTypesReports",
        },
        {
          title: "writing-cases-types-reports",
          url: "/writing-cases-types-reports",
          permission: "writingCasesTypesReports",
        },
        {
          title: "inquiries-status-reports",
          url: "/inquiries-status-reports",
          permission: "inquiriesStatusReports",
        },
        {
          title: "cases-status-reports",
          url: `/cases-status-reports/${ServicesSlug.COURT_SERVICES}`,
          permission: "casesStatusReports",
        },
        {
          title: "writing-cases-status-reports",
          url: `/cases-status-reports/${ServicesSlug.LEGAL_SERVICES}`,
          permission: "casesStatusReports",
        },
        {
          title: "evaluations-inquiries-reports",
          url: `/evaluations-cases-reports/${ServicesSlug.INQUIRY_SERVICES}`,
          permission: "evaluationsCasesReports",
        },
        {
          title: "evaluations-cases-reports",
          url: `/evaluations-cases-reports/${ServicesSlug.COURT_SERVICES}`,
          permission: "evaluationsCasesReports",
        },
        {
          title: "evaluations-writing-cases-reports",
          url: `/evaluations-cases-reports/${ServicesSlug.LEGAL_SERVICES}`,
          permission: "evaluationsCasesReports",
        },
        // {
        //   title: "evaluations-inquiries-reports",
        //   url: "/evaluations-inquiries-reports",
        //   permission: "evaluationsInquiriesReports",
        // },
        {
          title: "reasons-cases-reports",
          url: "/reasons-cases-reports",
          permission: "reasonsCasesReports",
        }
      ],
    },
    {
      title: "services-type",
      url: "/services",
      iconImageName: "services.png",
    },
  ];
}
